/*
  Business gifting landing page (WONDR).

  The page is built from separate business-gifting-* sections. Shopify does not
  let sections read each other's settings, so the "boxes & pricing" section
  prints the shared config (boxes, tiers, VAT) as JSON and this script wires
  every other section to it:

  - [data-bg-token]       placeholders such as [min_pct] or [best_price]
  - [data-bg-tiers]       the tier table
  - [data-bg-calculator]  the price calculator, upsell and checkout
  - [data-bg-form]        the invoice / quote request form

  Every section loads this file, so it guards itself against running twice.
  In the theme editor it re-initialises when a section is re-rendered.
*/
(function () {
  if (window.BusinessGifting) return;

  var STRINGS = {
    rrpRow: 'Winkelprijs incl. btw',
    rangeTo: 'tot',
    boxesSuffix: 'boxes',
    moreThan: 'Meer dan',
    customPrice: 'Prijs op maat, neem contact op',
    noBoxes: 'Nog geen boxes gekozen.',
    pickPrompt: 'Kies hieronder hoeveel boxes je wil. Vanaf {min} stuks krijg je korting.',
    toFirstTier: 'Nog {n} {boxes} en je zit aan de eerste staffel (-{pct}).',
    toNextTier: 'Nog {n} {boxes} erbij en je krijgt -{pct} op alles. Gemiddeld betaal je dan {avg} per box excl. btw.',
    viaQuote: 'Deze combinatie bestel je via het formulier: laat je gegevens achter.',
    perBox: 'per box excl. btw',
    rrpLabel: 'Winkelprijs',
    less: 'Minder',
    more: 'Meer',
    quantity: 'Aantal',
    mixedDelivery: 'Je boxes worden samen geleverd. {note}',
    closed: 'Niet meer te bestellen dit jaar.',
    freeShipping: 'Gratis',
    orderErrors: {
      rate_limited: 'Je hebt net al een paar bestellingen geplaatst. Probeer het over een uur opnieuw of neem contact met ons op.',
      below_minimum: 'Kies minstens {min} boxes om te bestellen.',
      above_maximum: 'Voor meer dan {max} boxes maken we een prijs op maat. Laat je gegevens achter.',
      missing_details: 'Vul alle verplichte velden in.',
      bad_email: 'Dat e-mailadres klopt niet helemaal.',
      bad_country: 'Kies een land uit de lijst.',
      not_your_location: 'Je account mag niet bestellen voor deze vestiging. Neem contact met ons op.',
      not_b2b: 'Log opnieuw in met je B2B-account om te bestellen.',
      unknown_box: 'Eén van je boxes kan je nog niet online bestellen. Laat je gegevens achter, dan regelen we het.',
      app_not_authorized: 'Online bestellen is even niet beschikbaar. Laat je gegevens achter, dan regelen we je bestelling.',
      box_closed: 'Die box kan je dit jaar niet meer bestellen.',
      unconfirmed:
        'We konden je bestelling niet bevestigen. Kijk eerst in je mailbox of de factuur is aangekomen voor je opnieuw bestelt, of neem contact met ons op.',
      fallback: 'Er ging iets mis bij het plaatsen van je bestelling. Probeer het opnieuw of neem contact met ons op.',
    },
    thinkPink: 'Samen gaat er {amount} naar Think Pink.',
    noTierDiscount: 'geen staffelkorting, {price} excl. btw per doosje',
    total: 'Totaal',
    discount: 'korting',
    exVat: 'excl. btw',
    incVat: 'incl. btw',
    customQuote: 'prijs op maat',
    requestTitle: 'BEDRIJFSGESCHENKEN AANVRAAG',
    cardText: 'Tekst kaartje',
    remark: 'Opmerking',
  };

  var currency = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR' });
  var number = new Intl.NumberFormat('nl-BE');

  function money(value) {
    return currency.format(value);
  }

  // Unit prices are rounded to the cent before they are multiplied, exactly as
  // the payment terms app does when it places the order.
  function round2(value) {
    return Math.round(value * 100) / 100;
  }

  function percent(value) {
    return String(value).replace('.', ',') + '%';
  }

  function plural(n) {
    return n === 1 ? 'box' : 'boxes';
  }

  function format(template, values) {
    return template.replace(/\{(\w+)\}/g, function (match, key) {
      return key in values ? values[key] : match;
    });
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function toInt(value) {
    return Math.max(0, parseInt(value, 10) || 0);
  }

  function readJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      // Without a valid config nothing on the page gets filled in, so make
      // the cause easy to find.
      console.error('Business gifting: invalid config', e, el);
      return null;
    }
  }

  function readConfig() {
    var cfg = readJson(document.querySelector('[data-bg-config]'));
    if (!cfg || !cfg.tiers || !cfg.tiers.length || !cfg.boxes) return null;
    cfg.tiers = cfg.tiers.slice().sort(function (a, b) {
      return a.min - b.min;
    });
    cfg.vat = typeof cfg.vat === 'number' ? cfg.vat : 0.21;
    cfg.maxQty = cfg.maxQty || 1000;
    cfg.minQty = cfg.tiers[0].min;
    cfg.bestTier = cfg.tiers[cfg.tiers.length - 1];
    // The page can be served from cache after a box's last order day, so the
    // browser checks the date too (a Belgian day, as the app does).
    var today = brusselsDate();
    cfg.boxes.forEach(function (box) {
      if (box.orderUntil && today > box.orderUntil) box.closed = true;
    });
    return cfg;
  }

  function brusselsDate() {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Brussels' }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }


  function findBox(cfg, key) {
    for (var i = 0; i < cfg.boxes.length; i++) {
      if (cfg.boxes[i].key === key) return cfg.boxes[i];
    }
    return null;
  }

  function tierFor(cfg, qty) {
    var tier = null;
    cfg.tiers.forEach(function (t) {
      if (qty >= t.min) tier = t;
    });
    return tier;
  }

  function nextTier(cfg, qty) {
    for (var i = 0; i < cfg.tiers.length; i++) {
      if (qty < cfg.tiers[i].min) return cfg.tiers[i];
    }
    return null;
  }

  function discounted(rrp, pct) {
    return rrp * (1 - pct / 100);
  }

  // A box's unit price excl. VAT in a tier: its fixed price for that tier when
  // the boxes section sets one, else the tier discount on the retail price.
  // The payment terms app prices orders the same way.
  function boxUnitEx(box, tier) {
    if (!tier) return round2(box.rrp);
    var fixed = null;
    (box.tierPrices || []).forEach(function (candidate) {
      if (tier.min >= candidate.min) fixed = candidate.price;
    });
    return fixed !== null ? fixed : round2(discounted(box.rrp, tier.pct));
  }

  // ------------------------------------------------------------ Tokens --

  function fillTokens(cfg) {
    var first = cfg.tiers[0];
    var global = {
      min_pct: percent(first.pct),
      max_pct: percent(cfg.bestTier.pct),
      min_qty: number.format(first.min),
      top_qty: number.format(cfg.bestTier.min),
      max_qty: number.format(cfg.maxQty),
    };

    document.querySelectorAll('[data-bg-token]').forEach(function (el) {
      var token = el.getAttribute('data-bg-token');
      if (token in global) {
        el.textContent = global[token];
        return;
      }
      var box = findBox(cfg, el.getAttribute('data-bg-box')) || cfg.boxes[cfg.boxes.length - 1];
      if (!box) return;
      if (token === 'rrp') el.textContent = money(box.rrp);
      if (token === 'start_price') el.textContent = money(boxUnitEx(box, first));
      if (token === 'best_price') el.textContent = money(boxUnitEx(box, cfg.bestTier));
    });
  }

  // ------------------------------------------------------- Tier table --

  function renderTiers(cfg) {
    document.querySelectorAll('[data-bg-tiers]').forEach(function (table) {
      var headRow = table.querySelector('thead tr');
      if (headRow) {
        headRow.querySelectorAll('[data-bg-box-head]').forEach(function (th) {
          th.remove();
        });
        cfg.boxes.forEach(function (box) {
          var th = document.createElement('th');
          th.setAttribute('data-bg-box-head', '');
          th.textContent = box.shortTitle || box.title;
          headRow.appendChild(th);
        });
      }

      var html = '<tr class="bg-rrp-row"><td>' + STRINGS.rrpRow + '</td><td></td>';
      cfg.boxes.forEach(function (box) {
        html += '<td>' + money(box.rrp) + '</td>';
      });
      html += '</tr>';

      cfg.tiers.forEach(function (tier, i) {
        var to = cfg.tiers[i + 1] ? cfg.tiers[i + 1].min - 1 : cfg.maxQty;
        var label = number.format(tier.min) + ' ' + STRINGS.rangeTo + ' ' + number.format(to) + ' ' + STRINGS.boxesSuffix;
        html += '<tr data-min="' + tier.min + '"><td>' + label + '</td><td>-' + percent(tier.pct) + '</td>';
        cfg.boxes.forEach(function (box) {
          html += '<td>' + money(boxUnitEx(box, tier)) + '</td>';
        });
        html += '</tr>';
      });

      html +=
        '<tr><td>' +
        STRINGS.moreThan +
        ' ' +
        number.format(cfg.maxQty) +
        '</td><td colspan="' +
        (cfg.boxes.length + 1) +
        '">' +
        STRINGS.customPrice +
        '</td></tr>';

      table.querySelector('tbody').innerHTML = html;
    });
  }

  function highlightTier(cfg, state) {
    document.querySelectorAll('[data-bg-tiers] tbody tr').forEach(function (tr) {
      var active = !!state.tier && String(state.tier.min) === tr.getAttribute('data-min') && !state.tooBig;
      tr.classList.toggle('is-active', active);
    });
  }

  // ----------------------------------------------------------- Summary --

  var app = {
    cfg: null,
    upsell: null,
    state: { lines: [], units: 0, pct: 0, ex: 0, inc: 0, tooBig: false, upQty: 0, upVar: null },
    cardText: function () {
      var el = document.querySelector('[data-bg-card]');
      return el ? el.value : '';
    },
  };

  function upsellUnitEx() {
    return app.upsell ? round2(app.upsell.rrp / (1 + app.cfg.vat)) : 0;
  }

  function summaryText() {
    var state = app.state;
    if (!state.units && !state.upQty) return STRINGS.noBoxes;

    var text = '';
    state.lines.forEach(function (line) {
      text += line.qty + ' x ' + line.box.title + '\n';
    });
    if (state.upQty) {
      text +=
        state.upQty +
        ' x ' +
        app.upsell.title +
        (state.upVar ? ' (' + state.upVar.title + ')' : '') +
        ' (' +
        format(STRINGS.noTierDiscount, { price: money(upsellUnitEx()) }) +
        ')\n';
    }
    text += STRINGS.total + ': ' + state.units + ' ' + STRINGS.boxesSuffix;
    if (state.tooBig) {
      text += ' (' + STRINGS.moreThan.toLowerCase() + ' ' + app.cfg.maxQty + ': ' + STRINGS.customQuote + ')';
    } else {
      text +=
        ' | ' +
        STRINGS.discount +
        ' -' +
        percent(state.pct) +
        ' | ' +
        money(state.ex) +
        ' ' +
        STRINGS.exVat +
        ' (' +
        money(state.inc) +
        ' ' +
        STRINGS.incVat +
        ')';
    }
    return text;
  }

  function syncFormSummaries() {
    var text = summaryText();
    document.querySelectorAll('[data-bg-form-summary]').forEach(function (el) {
      el.textContent = text;
    });
  }

  // ------------------------------------------------------------ Orders --

  /**
   * Sends the chosen boxes to the payment terms app, which prices and places
   * the order (see "Gifting orders" on the calculator). Resolves with the
   * app's answer: an invoiceUrl when the buyer finishes in a checkout, or the
   * order name and email when an invoice order was placed directly.
   */
  function sendOrder(mode, details) {
    var state = app.state;
    var url = app.orderUrl + '?mode=' + encodeURIComponent(mode);
    if (app.location) url += '&company_location_id=' + encodeURIComponent(app.location);
    // ?gifting_test=<token> on the page turns the order into a 1 euro test
    // order; the app only honours a token it knows.
    var testToken = new URLSearchParams(window.location.search).get('gifting_test');
    if (testToken) url += '&test=' + encodeURIComponent(testToken);
    var payload = {
      boxes: state.lines.map(function (line) {
        return { key: line.box.key, handle: line.box.handle, quantity: line.qty };
      }),
      upsell: state.upQty && state.upVar ? { variantId: state.upVar.id, quantity: state.upQty } : null,
      details: details,
    };

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
    });
  }

  // Problems on our side, not in the buyer's order: offer the form instead, so
  // nobody gets stuck on a button that cannot work right now.
  function needsFormFallback(code) {
    return !code || code === 'app_not_authorized' || code === 'unknown_box' || code === 'internal_error' || code === 'not_configured';
  }

  function orderErrorMessage(code) {
    var template = STRINGS.orderErrors[code] || STRINGS.orderErrors.fallback;
    return format(template, { min: app.cfg.minQty, max: number.format(app.cfg.maxQty) });
  }

  // A B2B buyer's order and paying now end in a checkout. Paying later does
  // not: Shopify offers payment terms at checkout to companies only, so the
  // buyer fills in the form and the app places the invoice order itself.
  function goesToCheckout(mode) {
    return mode === 'pay_now' || mode === 'order';
  }

  // -------------------------------------------------------- Calculator --

  function renderPicker(cfg, root) {
    var pick = root.querySelector('[data-bg-pick]');
    if (!pick) return;
    var presets = (root.getAttribute('data-bg-presets') || '')
      .split(',')
      .map(function (v) {
        return toInt(v);
      })
      .filter(Boolean);

    var html = '';
    cfg.boxes.forEach(function (box) {
      html += '<div class="bg-pick__card bg-card' + (box.closed ? ' is-closed' : '') + '">';
      html += '<div class="bg-pick__img">';
      if (box.image) {
        html += '<img src="' + escapeHtml(box.image) + '" alt="' + escapeHtml(box.imageAlt || box.title) + '" loading="lazy" width="600" height="450">';
      }
      html += '</div><div class="bg-pick__body">';
      html += '<div class="bg-pick__name">' + escapeHtml(box.title) + '</div>';
      html += '<div class="bg-pick__unit"><strong data-bg-unit="' + box.key + '"></strong> ' + STRINGS.perBox + '</div>';
      html += '<div class="bg-pick__rrp">' + STRINGS.rrpLabel + ' ' + money(box.rrp) + '</div>';
      html += '<p class="bg-pick__note" data-bg-note></p>';
      html += '<div class="bg-stepper">';
      html += '<button type="button" data-bg-minus aria-label="' + STRINGS.less + '">&minus;</button>';
      html +=
        '<input type="number" min="0" step="1" value="0" inputmode="numeric" data-bg-qty="' +
        box.key +
        '" aria-label="' +
        STRINGS.quantity +
        ' ' +
        escapeHtml(box.title) +
        '">';
      html += '<button type="button" data-bg-plus aria-label="' + STRINGS.more + '">+</button>';
      html += '</div>';
      if (presets.length) {
        html += '<div class="bg-presets">';
        presets.forEach(function (preset) {
          html += '<button type="button" class="bg-chip" data-bg-preset="' + preset + '">' + preset + '</button>';
        });
        html += '</div>';
      }
      html += '</div></div>';
    });
    pick.innerHTML = html;
  }

  function initCalculator(root) {
    // Re-initialising (theme editor) only rebuilds the picker; the other
    // listeners are still attached to the same elements.
    if (root.bgRefresh) {
      root.bgRefresh();
      return;
    }

    var step = toInt(root.getAttribute('data-bg-step')) || 1;
    var upsell = readJson(root.querySelector('[data-bg-upsell-config]'));
    var upEl = root.querySelector('[data-bg-upsell]');
    if (!upEl) upsell = null;
    if (upsell && upsell.rrp == null) {
      // Same rule as the boxes: B2B product prices are excl. VAT.
      upsell.rrp = app.cfg.pricesIncludeVat ? upsell.price : Math.round(upsell.price * (1 + app.cfg.vat) * 100) / 100;
    }
    app.upsell = upsell;

    var upQty = upEl ? upEl.querySelector('[data-bg-up-qty]') : null;
    var upMatch = upEl ? upEl.querySelector('[data-bg-up-match]') : null;
    var upVar = upsell && upsell.variants.length ? upsell.variants[0] : null;

    var shippingPrice = parseFloat(root.getAttribute('data-bg-shipping')) || 0;
    var freeShippingFrom = parseFloat(root.getAttribute('data-bg-free-shipping')) || 0;
    var out = {
      shipping: root.querySelector('[data-bg-shipping-cost]'),
      units: root.querySelector('[data-bg-units]'),
      tier: root.querySelector('[data-bg-tier]'),
      rrp: root.querySelector('[data-bg-rrp]'),
      save: root.querySelector('[data-bg-save]'),
      ex: root.querySelector('[data-bg-ex]'),
      vat: root.querySelector('[data-bg-vat]'),
      inc: root.querySelector('[data-bg-inc]'),
      nudge: root.querySelector('[data-bg-nudge]'),
      big: root.querySelector('[data-bg-big]'),
      upRow: root.querySelector('[data-bg-up-row]'),
    };
    var orderButtons = {
      order: root.querySelector('[data-bg-order="order"]'),
      pay_now: root.querySelector('[data-bg-order="pay_now"]'),
      invoice: root.querySelector('[data-bg-order="invoice"]'),
      quote: root.querySelector('[data-bg-order="quote"]'),
    };
    app.orderUrl = root.getAttribute('data-bg-order-url') || '';
    app.location = root.getAttribute('data-bg-location') || '';
    var inputs = [];
    var deliveryEl = root.querySelector('[data-bg-delivery]');
    var deliveryDefault = deliveryEl ? deliveryEl.textContent.trim() : '';

    function setText(el, value) {
      if (el) el.textContent = value;
    }

    function readLines() {
      var lines = [];
      var units = 0;
      inputs.forEach(function (input) {
        var qty = toInt(input.value);
        var box = findBox(app.cfg, input.getAttribute('data-bg-qty'));
        if (qty > 0 && box) lines.push({ box: box, qty: qty });
        units += qty;
      });
      return { lines: lines, units: units };
    }

    function upsellCount(units) {
      if (!upsell || !upQty) return 0;
      if (upMatch && upMatch.checked) {
        upQty.value = units;
        upQty.disabled = true;
      } else {
        upQty.disabled = false;
      }
      return toInt(upQty.value);
    }

    // Locks the boxes past their last order day and says so on their card.
    function lockClosedCards() {
      inputs.forEach(function (input) {
        var box = findBox(app.cfg, input.getAttribute('data-bg-qty'));
        if (!box) return;
        var card = input.closest('.bg-pick__card');
        if (box.closed) input.value = 0;
        card.classList.toggle('is-closed', Boolean(box.closed));
        card.querySelectorAll('input, button').forEach(function (el) {
          el.disabled = Boolean(box.closed);
        });
        var note = card.querySelector('[data-bg-note]');
        if (note) setText(note, box.closed ? STRINGS.closed : box.orderUntilNote || '');
      });
    }

    // An order ships in one go, so it arrives with its slowest box. Mixing
    // boxes with different delivery times says so.
    function deliveryFor(lines) {
      var slowest = null;
      var notes = {};
      lines.forEach(function (line) {
        if (!line.box.deliveryNote) return;
        notes[line.box.deliveryNote] = true;
        if (!slowest || (line.box.deliveryDays || 0) > (slowest.deliveryDays || 0)) slowest = line.box;
      });
      if (!slowest) return deliveryDefault;
      if (Object.keys(notes).length > 1) return format(STRINGS.mixedDelivery, { note: slowest.deliveryNote });
      return slowest.deliveryNote;
    }

    function render() {
      lockClosedCards();
      var read = readLines();
      var tier = tierFor(app.cfg, read.units);
      var pct = tier ? tier.pct : 0;
      var rrp = 0;
      read.lines.forEach(function (line) {
        rrp += line.box.rrp * line.qty;
      });
      var boxEx = 0;
      read.lines.forEach(function (line) {
        boxEx += boxUnitEx(line.box, tier) * line.qty;
      });
      var uq = upsellCount(read.units);
      var goods = round2(boxEx + uq * upsellUnitEx());
      // Shipping excl. VAT per order, free from an order value excl. VAT; the
      // payment terms app charges it the same way.
      var shipping = goods > 0 && !(freeShippingFrom > 0 && goods >= freeShippingFrom) ? shippingPrice : 0;
      var ex = goods + shipping;
      var inc = ex * (1 + app.cfg.vat);
      var tooBig = read.units > app.cfg.maxQty;

      setText(out.units, read.units);
      setText(out.tier, tier ? '-' + percent(pct) : '-');
      setText(out.rrp, money(rrp + (upsell ? uq * upsell.rrp : 0)));
      setText(out.save, money(rrp - boxEx));
      setText(out.shipping, !goods ? '-' : shipping ? money(shipping) : STRINGS.freeShipping);
      setText(out.ex, money(ex));
      setText(out.vat, money(inc - ex));
      setText(out.inc, money(inc));

      if (out.upRow) {
        out.upRow.classList.toggle('bg-hidden', !uq);
        setText(out.upRow.querySelector('[data-bg-up-sum]'), uq + ' x ' + money(upsellUnitEx()));
      }
      if (upEl) {
        setText(
          upEl.querySelector('[data-bg-up-tp]'),
          uq ? format(STRINGS.thinkPink, { amount: money(uq * (upsell.donation || 5)) }) : ''
        );
      }

      var unitTier = tier || app.cfg.tiers[0];
      app.cfg.boxes.forEach(function (box) {
        root.querySelectorAll('[data-bg-unit="' + box.key + '"]').forEach(function (el) {
          el.textContent = money(boxUnitEx(box, unitTier));
        });
      });

      var next = nextTier(app.cfg, read.units);
      var msg = '';
      if (read.units === 0) {
        msg = format(STRINGS.pickPrompt, { min: app.cfg.minQty });
      } else if (read.units < app.cfg.minQty) {
        var missingQty = app.cfg.minQty - read.units;
        msg = format(STRINGS.toFirstTier, { n: missingQty, boxes: plural(missingQty), pct: percent(app.cfg.tiers[0].pct) });
      } else if (next && !tooBig) {
        var extra = next.min - read.units;
        msg = format(STRINGS.toNextTier, {
          n: extra,
          boxes: plural(extra),
          pct: percent(next.pct),
          avg: money(discounted(rrp / read.units, next.pct)),
        });
      }

      // Up to the maximum the app places the order; above it only the form is
      // offered. A box the storefront cannot see (an unpublished product) has
      // no handle here, but the app still finds it by its key.
      var ok = read.units >= app.cfg.minQty && !tooBig;
      var orderable = ok;
      if (ok && !orderable) msg = (msg ? msg + ' ' : '') + STRINGS.viaQuote;
      setText(out.nudge, msg);
      if (out.big) out.big.classList.toggle('bg-hidden', !tooBig);
      ['order', 'pay_now', 'invoice'].forEach(function (mode) {
        var btn = orderButtons[mode];
        if (!btn) return;
        btn.disabled = !orderable;
        btn.classList.toggle('bg-hidden', tooBig || (ok && !orderable));
      });
      if (orderButtons.quote) orderButtons.quote.classList.toggle('bg-hidden', !(tooBig || (ok && !orderable)));

      var delivery = deliveryFor(read.lines);
      if (deliveryEl) setText(deliveryEl, delivery);

      app.state = {
        delivery: delivery,
        lines: read.lines,
        units: read.units,
        tier: tier,
        pct: pct,
        rrp: rrp,
        ex: ex,
        inc: inc,
        tooBig: tooBig,
        ok: ok,
        orderable: orderable,
        upQty: uq,
        upVar: upVar,
      };
      highlightTier(app.cfg, app.state);
      syncFormSummaries();
      if (app.form) app.form.sync();
    }

    if (upEl && upsell) {
      upEl.querySelectorAll('[data-bg-up-price]').forEach(function (el) {
        el.textContent = money(upsellUnitEx());
      });
      upEl.querySelectorAll('[data-bg-up-var]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          upEl.querySelectorAll('[data-bg-up-var]').forEach(function (other) {
            other.classList.remove('is-on');
            other.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-on');
          btn.setAttribute('aria-pressed', 'true');
          var id = btn.getAttribute('data-bg-up-var');
          upVar =
            upsell.variants.filter(function (v) {
              return String(v.id) === id;
            })[0] || upVar;
          render();
        });
      });
      upQty.addEventListener('input', render);
      if (upMatch) {
        upMatch.addEventListener('change', function () {
          // Unticking "one per box" undoes it instead of leaving the copied count.
          if (!upMatch.checked) upQty.value = 0;
          render();
        });
      }
      upEl.querySelector('[data-bg-up-minus]').addEventListener('click', function () {
        if (upMatch) upMatch.checked = false;
        upQty.value = Math.max(0, toInt(upQty.value) - 1);
        render();
      });
      upEl.querySelector('[data-bg-up-plus]').addEventListener('click', function () {
        if (upMatch) upMatch.checked = false;
        upQty.value = toInt(upQty.value) + 1;
        render();
      });
    }

    var orderError = root.querySelector('[data-bg-order-error]');

    function showOrderError(message) {
      if (!orderError) return;
      orderError.textContent = message;
      orderError.classList.toggle('bg-hidden', !message);
    }

    function checkout(mode, btn) {
      if (!app.state.orderable || btn.getAttribute('aria-busy') === 'true') return;
      showOrderError('');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      sendOrder(mode, { cardText: app.cardText() })
        .then(function (data) {
          window.location.href = data.invoiceUrl;
        })
        .catch(function (data) {
          var code = data && data.error;
          console.warn('Business gifting: order failed', data);
          showOrderError(orderErrorMessage(code));
          if (needsFormFallback(code) && orderButtons.quote) orderButtons.quote.classList.remove('bg-hidden');
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        });
    }

    Object.keys(orderButtons).forEach(function (mode) {
      var btn = orderButtons[mode];
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (mode !== 'quote' && goesToCheckout(mode)) {
          checkout(mode, btn);
        } else if (app.form) {
          app.form.open(mode, { scroll: true });
        }
      });
    });

    function setupPicker() {
      app.upsell = upsell;
      renderPicker(app.cfg, root);
      inputs = root.querySelectorAll('[data-bg-qty]');

      inputs.forEach(function (input) {
        input.addEventListener('input', render);
        var wrap = input.closest('.bg-stepper');
        wrap.querySelector('[data-bg-minus]').addEventListener('click', function () {
          input.value = Math.max(0, toInt(input.value) - step);
          render();
        });
        wrap.querySelector('[data-bg-plus]').addEventListener('click', function () {
          input.value = toInt(input.value) + step;
          render();
        });
      });

      root.querySelectorAll('[data-bg-preset]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = btn.closest('.bg-pick__card').querySelector('[data-bg-qty]');
          input.value = btn.getAttribute('data-bg-preset');
          render();
        });
      });

      render();
    }

    root.bgRefresh = setupPicker;
    setupPicker();
  }

  // -------------------------------------------------------- Order form --

  /**
   * One form behind three buttons. "quote" is a Shopify contact form, for more
   * boxes than the maximum. "invoice" and "pay_now" send the same fields to the
   * payment terms app, which prices and places the order itself; pay_now then
   * sends the buyer to the order's payment page.
   */
  function initForm(root) {
    var form = root.querySelector('form');
    if (!form) return;
    var klaviyoKey = root.getAttribute('data-bg-klaviyo');
    var errorBox = root.querySelector('[data-bg-form-error]');
    var submit = form.querySelector('[data-bg-submit]');
    var designMode = window.Shopify && window.Shopify.designMode;
    // Only an automatically opened form (crossing the maximum) closes itself again.
    var openedByLimit = false;

    function setMode(mode) {
      root.setAttribute('data-bg-mode', mode);
    }

    function show(visible) {
      if (designMode) return;
      root.classList.toggle('bg-hidden', !visible);
    }

    function open(mode, options) {
      openedByLimit = false;
      setMode(mode);
      showError('');
      show(true);
      if (options && options.scroll) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var first = form.querySelector('[data-bg-detail]:not([data-bg-detail="website"])');
        if (first) {
          setTimeout(function () {
            first.focus({ preventScroll: true });
          }, 500);
        }
      }
    }

    // Keeps the form in step with the calculator: above the maximum it becomes
    // the quote form on its own, and goes away again when the count drops.
    function sync() {
      var state = app.state;
      var mode = root.getAttribute('data-bg-mode');
      if (state.tooBig) {
        if (mode !== 'quote') {
          setMode('quote');
          openedByLimit = !mode || root.classList.contains('bg-hidden');
          show(true);
        }
      } else if (mode === 'quote' && openedByLimit) {
        openedByLimit = false;
        show(false);
      }
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.classList.toggle('bg-hidden', !message);
    }

    function details() {
      var values = {};
      form.querySelectorAll('[data-bg-detail]').forEach(function (el) {
        values[el.getAttribute('data-bg-detail')] = el.value;
      });
      values.cardText = app.cardText();
      return values;
    }

    function busy(on) {
      if (!submit) return;
      submit.disabled = on;
      if (on) submit.setAttribute('aria-busy', 'true');
      else submit.removeAttribute('aria-busy');
    }

    function placeOrder(mode) {
      var state = app.state;
      if (!state.orderable) {
        showError(orderErrorMessage(state.tooBig ? 'above_maximum' : 'below_minimum'));
        return;
      }

      busy(true);
      showError('');
      sendOrder(mode, details())
        .then(function (data) {
          if (data.invoiceUrl) {
            window.location.href = data.invoiceUrl;
            return;
          }
          var success = (root.getAttribute('data-bg-invoice-success') || '')
            .replace('[order]', data.name || '')
            .replace('[email]', data.email || '')
            .replace('[delivery]', app.state.delivery || '');
          form.innerHTML = '<div class="bg-success">' + escapeHtml(success) + '</div>';
        })
        .catch(function (data) {
          var code = data && data.error;
          console.warn('Business gifting: order failed', data);
          // No answer from the app (a timeout, a proxy page): the order may
          // well exist, so neither offer the form nor let it be sent twice.
          if (!code && mode === 'invoice') {
            showError(STRINGS.orderErrors.unconfirmed);
            return;
          }
          // The same fields can still go out as a request by mail.
          if (needsFormFallback(code)) setMode('quote');
          showError(orderErrorMessage(code));
          busy(false);
        });
    }

    form.addEventListener('submit', function (event) {
      var mode = root.getAttribute('data-bg-mode') || 'quote';
      if (mode !== 'quote') {
        event.preventDefault();
        if (form.reportValidity()) placeOrder(mode);
        return;
      }
      fillQuote();
    });

    // The quote form is a Shopify contact form; the chosen boxes ride along in
    // the message body, and optionally as a Klaviyo event.
    function fillQuote() {
      var state = app.state;
      var card = app.cardText();
      var field = function (name) {
        var el = form.querySelector('[name="contact[' + name + ']"]');
        return el ? el.value : '';
      };
      var address = [field('Straat en nummer'), field('Postcode') + ' ' + field('Gemeente'), field('Land')]
        .map(function (part) {
          return part.trim();
        })
        .filter(Boolean)
        .join(', ');

      var text = STRINGS.requestTitle + '\n\n' + summaryText();
      if (card) text += '\n\n' + STRINGS.cardText + ':\n' + card;
      if (field('Opmerking')) text += '\n\n' + STRINGS.remark + ':\n' + field('Opmerking');

      var body = form.querySelector('[name="contact[body]"]');
      if (body) body.value = text;
      var order = form.querySelector('[name="contact[Bestelling]"]');
      if (order) order.value = summaryText();
      var cardField = form.querySelector('[name="contact[Tekst kaartje]"]');
      if (cardField) cardField.value = card;

      if (!klaviyoKey) return;
      var payload = {
        data: {
          type: 'event',
          attributes: {
            properties: {
              company: field('Bedrijf'),
              vat_number: field('BTW-nummer'),
              delivery_address: address,
              delivery_date: field('Gewenste leverdatum'),
              card_text: card,
              remark: field('Opmerking'),
              units: state.units,
              discount_pct: state.pct,
              total_excl_vat: Math.round(state.ex * 100) / 100,
              total_incl_vat: Math.round(state.inc * 100) / 100,
              too_big: state.tooBig,
              lines: state.lines.map(function (line) {
                return { box: line.box.title, qty: line.qty };
              }),
              upsell_qty: state.upQty || 0,
              upsell_variant: state.upVar ? state.upVar.title : '',
              summary: summaryText(),
            },
            value: Math.round(state.ex * 100) / 100,
            metric: { data: { type: 'metric', attributes: { name: 'Business Gift Request' } } },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: field('email'),
                  first_name: field('name'),
                  organization: field('Bedrijf'),
                  properties: { business_gifting_lead: true },
                },
              },
            },
          },
        },
      };
      try {
        fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(klaviyoKey), {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify(payload),
        });
      } catch (e) {}
    }

    // A posted contact form reloads the page; show its result instead of
    // hiding it behind the buttons.
    if (root.querySelector('[data-bg-form-posted]')) {
      setMode('quote');
    } else {
      show(false);
    }

    app.form = { open: open, sync: sync };
  }

  // -------------------------------------------------------------- Init --

  function init() {
    var cfg = readConfig();
    app.cfg = cfg;
    if (!cfg) return;

    fillTokens(cfg);
    renderTiers(cfg);
    app.upsell = null;
    // The form first: the calculator's first render already talks to it.
    document.querySelectorAll('[data-bg-form]').forEach(function (root) {
      if (root.bgBound) return;
      root.bgBound = true;
      initForm(root);
    });
    document.querySelectorAll('[data-bg-calculator]').forEach(function (root) {
      initCalculator(root);
    });
    syncFormSummaries();
  }

  window.BusinessGifting = { init: init };

  // "Wat zit er in de box?": opens the box contents pop-up. Delegated, so it
  // survives section re-renders. A click on the backdrop lands on the dialog itself.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bg-contents]');
    var dialog = trigger && document.getElementById(trigger.getAttribute('data-bg-contents'));
    if (dialog && !dialog.open) dialog.showModal();
    else if (e.target.matches('dialog.bg-contents')) e.target.close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', function () {
      setTimeout(init);
    });
  }
})();
